module.exports = __webpack_public_path__ + "img/espa-2021-2027.2261483c.svg";